import classNames from 'classnames';
import {
  Checkbox,
  ContentBlock,
  DateInput,
  FlexContainer,
  Txt,
} from 'components';
import { fromSwiftDate, toSwiftDate } from 'helpers/swiftDateFormatter';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';
import { useProperty } from 'state';
import styles from './PropertySearchScreen.module.scss';

/**
 * PropertySearchScreen
 *
 * @return {JSX.Element}
 */
const PropertySearchScreen = ({ className, highlight }) => {
  const ref = useRef();
  const property = useProperty();
  const { data: dataState } = property;

  const handleSearchToggle = (e) => {
    const currentData = toSwiftDate(new Date());
    const data = {
      search: {
        ...dataState.search,
        onTheMarket: e.target.checked,
      },
      dateUpdated: currentData,
    };

    // If available and no date, just add it
    if (data.search.tenancyAvailable && !dataState.search?.dateAvailable) {
      data.search.dateAvailable = currentData;
    }

    property.update(data);
  };

  const handleDateChange = ({ target: { value } }) => {
    property.update({
      search: {
        ...dataState.search,
        dateAvailable: toSwiftDate(value),
      },
    });
  };

  useEffect(() => {
    if (highlight) {
      ref.current.scrollIntoView?.();
      // console.log(ref.current);
    }
  }, [highlight]);

  const onTheMarket = dataState.search?.onTheMarket;

  return (
    <ContentBlock
      className={classNames(
        styles.PropertySearchScreen,
        className,
        PropertySearchScreen.displayName
      )}
      column
      gap
      animate={highlight}
      ref={ref}
    >
      <Checkbox
        toggler
        reverse
        onChange={handleSearchToggle}
        checked={onTheMarket}
      >
        <FlexContainer column gapQuad>
          <Txt xx>{onTheMarket ? 'On the Market' : 'Off the Market'}</Txt>
          <Txt regular>
            Tenants will be able to search for this property in the search area.
            They will have access to your email and can contact you if they want
            to arrange a viewing.
          </Txt>
        </FlexContainer>
      </Checkbox>
      {onTheMarket ? (
        <FlexContainer alignCenter gapHalf>
          <Txt>Available from: </Txt>
          <DateInput
            value={
              dataState.search
                ? fromSwiftDate(dataState.search.dateAvailable)
                : ''
            }
            onChange={handleDateChange}
            name="dateAvailable"
            minDate={new Date()}
            customLabel=" (edit)"
          />
        </FlexContainer>
      ) : null}
    </ContentBlock>
  );
};

PropertySearchScreen.displayName = 'PropertySearchScreen';

export default observer(PropertySearchScreen);
